module.exports = __webpack_public_path__ + "img/move-horsetrack-hero.020ff3db.png";